
import { mapGetters, mapActions } from 'vuex';
import { formatData } from '../../../constants/config.js'
export default {
    components: {
        vcLoading   : () => import('../../../components/pages/loading.vue'),
        breadcrumbs : () => import('../../../components/pages/breadcrumbs.vue'),
        vcFormField : () => import("../../../components/pages/form-field.vue"),
        profileImage: () => import('../../../components/account/profile-image.vue')
    },
    data() {
        return {
            isLoadingPage   : true,
            percent_range   : 0,
            disabled_fields : true,
            customer        : {
                email       : '',
                first_name  : '',
                last_name   : '',
                phone       : null
            },
            listPhoneCodes  : [],
            update_phone    : {
                code        : '52',
                country_code: 'MX',
                number      : '',
                format      : ''
            },
        };
    },
    async mounted(){
        
        await this.getCountries().then( async (result_countries) => {
            
            this.listPhoneCodes = this.getterCountries.phone_codes;
            await this.getCustomer({ id_email: this.getterUser.email }).then( async (result_customer) => {
                
                this.customer   = {
                    email       : this.getterCustomer.email,
                    first_name  : this.getterCustomer.first_name,
                    last_name   : this.getterCustomer.last_name,
                    phone       : this.getterCustomer.phone || null
                };
                
                this.update_phone = this.getterCustomer.phone === null ? this.update_phone : this.getterCustomer.phone;

                setTimeout( () => {
                    this.$root.$emit('update-profile-image', this.getterProfileImage);
                }, 500);
                
                await this.getLevelCustomer().then( (result_level) => {
                    
                    let num_range = this.getterLevel != null ? ( this.getterLevel.total_fact * 100 ) / this.getterLevel.nextLevel.lowerLimit : 0;
                    
                    this.percent_range = num_range > 100 ? 100 : num_range;
                });
                this.$root.$on('update-field-value'     , this.updateFieldValue);
            });
        });
        this.isLoadingPage = null;
    },
    computed: {
        ...mapGetters({
            getterTranslates    : 'getterTranslates',
            getterStoreLang	    : 'getterStoreLang',
            getterUser          : 'getterUser',
            getterLevel         : 'getterLevel',
            getterProfileImage  : 'getterProfileImage',
            getterCustomer      : 'getterCustomer',
            getterCountries     : 'getterCountries', 
        }),
        getIsLoadingPage(){
            return this.isLoadingPage;
        },
        getPhoneData(){
            return this.update_phone;
        },
        getCustomerInfo(){
            return this.customer;
        },
        getDisabledFields(){
            return this.disabled_fields;
        }
    },
    methods: {
        ...mapActions({
            updateCustomer          : 'updateCustomer', 
            updateCustomerAddress   : 'updateCustomerAddress',
            getCountries            : 'getCountries',
            getCustomer             : 'getCustomer',
            getLevelCustomer        : 'getLevelCustomer',
            changeProfileImage      : 'changeProfileImage',
            logoutUser              : 'logoutUser',
        }),
        updateFieldValue(data){

            if( data.field === 'phone' ){
                this.update_phone    = data.value;
                this.customer.phone  = data.value.format;
            }
            else{
                this.customer[data.field] = data.value;
            }
        },
        editInfoAccount() {
            this.disabled_fields = !this.disabled_fields;
        },
        hideInfo() {
            this.showFormInfo = false;
        },
        async saveChangeInfo() {
            let body_request = {
                old_email   : this.getterCustomer.email,
                email       : this.customer.email,
                agent_email : this.getterCustomer.agent_email,
                first_name  : this.customer.first_name,
                last_name   : this.customer.last_name,
                phone       : this.customer.phone.format,
                is_wholesale: true
            };
            await this.updateCustomer(body_request).then( (result_customer) => {
                
                this.hideInfo();
            });
        },
        searchImage(){
            
            document.getElementById('profile_image').click();
        },
        async chargeImage(){
            let body_request = { 
                file: document.getElementById('profile_image').files[0],
                input_name: 'profile_image',
                max_size: 512000,
                old_path_file: this.getterUser ? this.getterUser.profile_image.replace(`${ this.$config.hefesto_file.baseURL }/`, '') : '', 
                extra_data: {
                    category_file: 'image',
                    body:[
                    { name: 'base_path', value: '/images/profiles' },
                    { name: 'max_dimension', value: JSON.stringify( { 'width': 2000, 'height': 2000 } ) },
                    { name: 'default_file_name', value: '' }
                    ]
                }
            };
            await this.changeProfileImage(body_request).then( (result_image) => {
                
                this.$root.$emit('update-profile-image', this.getterProfileImage);
            });
            this.$refs['profile_image'].reset();
        },
        formatCurrency( amount_value ){
            
            return formatData.currency( amount_value );
        },
        logout() {
            this.logoutUser({});
            this.$router.push('/account/login');
        },
    }
}
